Vue.component('SpireBloodResultsIndexComponent', require('./components/SpireBloodResultsIndexComponent').default);
Vue.component('SpireBloodResultTabsComponent', require('./components/partials/SpireBloodResultTabsComponent').default);
Vue.component(
    'SpireBloodLinkedResultsDataTable',
    require('./components/partials/SpireBloodLinkedResultsDataTable').default
);
Vue.component(
    'SpireBloodMissingResultsDataTable',
    require('./components/partials/SpireBloodMissingResultsDataTable').default
);
Vue.component('SpireFtpPreviewModal', require('./components/partials/SpireFtpPreviewModal').default);
